module.exports = __webpack_public_path__ + "static/media/4.b9d11cee.jpg";